module.exports = __webpack_public_path__ + "img/形状 18@2x.f13bda66.png";